const draw_icon = {
    namespaced: true,
    state: {
        

    },
    mutations: {
      
    },
    actions: {
    }
  }
  
  export default draw_icon
  


// WEBPACK FOOTER //
// ./src/vuex/modules/draw_icon.js